import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { api } from "../services/api";
import PageHeader from "./ui/PageHeader";
import StatCard from "./ui/StatCard";
import DataCard from "./ui/DataCard";
import LoadingState from "./ui/LoadingState";

const AnalyticsInsights = () => {
  const [reports, setReports] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getReports().then(setReports).finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingState message="Loading analytics..." />;

  const revenueData = [...reports.monthly].reverse().map((m) => ({
    period: m.month.slice(5),
    revenue: parseFloat(m.revenue || 0),
  }));

  const transactionData = reports.byCategory.map((c) => ({
    type: c.bill_type?.replace(" Bill", "").replace(" Payment", "") || c.bill_type,
    count: parseInt(c.txn_count, 10),
  }));

  const totalRevenue = reports.byCategory.reduce((s, c) => s + parseFloat(c.revenue || 0), 0);
  const totalTxns = reports.byCategory.reduce((s, c) => s + parseInt(c.txn_count, 10), 0);

  return (
    <div>
      <PageHeader title="Analytics" subtitle="Bill payment trends and performance insights" />

      <Row className="g-3 mb-4">
        <Col md={4}>
          <StatCard label="Total Revenue" value={`₹${totalRevenue.toLocaleString("en-IN")}`} accent="#10b981" iconBg="#d1fae5" />
        </Col>
        <Col md={4}>
          <StatCard label="Total Transactions" value={totalTxns} accent="#6366f1" iconBg="#eef2ff" />
        </Col>
        <Col md={4}>
          <StatCard label="Avg Ticket Size" value={`₹${totalTxns ? Math.round(totalRevenue / totalTxns) : 0}`} accent="#f59e0b" iconBg="#fef3c7" />
        </Col>
      </Row>

      <Row className="g-3 mb-4">
        <Col lg={6}>
          <DataCard title="Monthly Revenue" padded>
            <ResponsiveContainer width="100%" height={280}>
              <LineChart data={revenueData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="period" tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} />
                <Tooltip formatter={(v) => [`₹${v.toLocaleString("en-IN")}`, "Revenue"]} />
                <Line type="monotone" dataKey="revenue" stroke="#6366f1" strokeWidth={2.5} dot={{ fill: "#6366f1" }} />
              </LineChart>
            </ResponsiveContainer>
          </DataCard>
        </Col>
        <Col lg={6}>
          <DataCard title="Transactions by Category" padded>
            <ResponsiveContainer width="100%" height={280}>
              <BarChart data={transactionData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="type" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 12 }} />
                <Tooltip />
                <Bar dataKey="count" fill="#10b981" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </DataCard>
        </Col>
      </Row>
    </div>
  );
};

export default AnalyticsInsights;
